import uScopeApi from 'uScope/js/public-api';
import {DstWrapper} from './DstWrapper';

uScopeApi.plugins.register({
  name: 'dst:wrapper',

  extends: 'uScope',

  dependencies: ['vil:wrapper'],

  constructor: DstWrapper
});



// WEBPACK FOOTER //
// ./src/slide-tray/uScope-extensions/dst-wrapper/index.js